import type { CreditRuleRequestFor, RuleSetFormData } from '../types';

export interface ProfessionalEducationState {
  creditRuleData: RuleSetFormData;
  hasRuleConfigured: boolean;
  configuredFor: string;
  configuredRequestFor: CreditRuleRequestFor;
}

function createEmptyFormData(): RuleSetFormData {
  return { rules: [], certificate: '', emailDesign: '' };
}

const state = (): ProfessionalEducationState => ({
  creditRuleData: createEmptyFormData(),
  hasRuleConfigured: false,
  configuredFor: '',
  configuredRequestFor: ''
});

const mutations = {
  setCreditRuleData(
    state: ProfessionalEducationState,
    payload: { id: string; requestFor: CreditRuleRequestFor; data: RuleSetFormData }
  ) {
    state.creditRuleData = payload.data;
    state.hasRuleConfigured = true;
    state.configuredFor = payload.id;
    state.configuredRequestFor = payload.requestFor;
  },
  clearCreditRuleData(state: ProfessionalEducationState) {
    state.creditRuleData = createEmptyFormData();
    state.hasRuleConfigured = false;
    state.configuredFor = '';
    state.configuredRequestFor = '';
  }
};

const getters = {
  getCreditRuleDataFor:
    (state: ProfessionalEducationState) =>
    (id: string, requestFor: CreditRuleRequestFor): RuleSetFormData | null => {
      if (state.configuredFor === id && state.configuredRequestFor === requestFor) {
        return state.creditRuleData;
      }
      return null;
    },
  isConfiguredFor:
    (state: ProfessionalEducationState) =>
    (id: string, requestFor: CreditRuleRequestFor): boolean => {
      return state.hasRuleConfigured && state.configuredFor === id && state.configuredRequestFor === requestFor;
    }
};

const actions = {
  // TODO: Integrate with API — POST/GET per entity using id + requestFor to build the URL
  saveCreditRuleData({ commit }, payload: { id: string; requestFor: CreditRuleRequestFor; data: RuleSetFormData }) {
    commit('setCreditRuleData', payload);
  },
  // TODO: Integrate with API — DELETE per entity using id + requestFor
  removeCreditRuleData({ commit }) {
    commit('clearCreditRuleData');
  },
  // TODO: Integrate with API — GET per entity; for now this is a no-op placeholder
  fetchCreditRuleData({ _commit }, _payload: { id: string; requestFor: CreditRuleRequestFor }) {
    // Will fetch from API and commit setCreditRuleData
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
